<router-outlet></router-outlet>
<app-metrika-noscript />
<app-analytics-consent-banner />
